var _jsxFileName = "/src/main/react/src/main/app/components/pages/TitleSearch.js";
import React, { Fragment } from 'react';
import { Grid, Typography, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import TpicPage from './TpicPage';
import queryString from "query-string";
import Util, { statesDontMatch } from "../../util/Util";
import { Loading, Pagination, SimpleSnackbar } from '../common';
import { ASPECT_RATIO, BASE_URIS, Q_STRING, SORT_FIELD, TPIS_PARAMS } from "../domain/constants";
import { determinePageSize, determineSelectedFilters, determineSortInfoFromQueryString, retrieveAndDecodeTitle, retrieveFromQueryString, setUpFiltersFromQueryString, setUpPageInfoFromQueryString, setUpRatioFromQueryString, setUpSortInfoFromQueryString } from "../../util/QueryStringUtil";
import { ENTITY_SELECTED } from "../Routes";
import SortsAndFilters from "../common/SortsAndFilters";
import { loadDisplayInfo } from "../../util/APIUtil";
const styles = () => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  },
  root: {
    width: '100%',
    marginTop: 0,
    overflowX: 'auto'
  },
  cell: {
    padding: 15,
    margin: 15
  }
});
class TitleSearch extends TpicPage {
  constructor(props) {
    super(props);
    const querystringValues = queryString.parse(props.location.search);
    const pageSize = determinePageSize(querystringValues, props);
    const sortInfo = determineSortInfoFromQueryString(querystringValues, props);
    const selectedFilters = determineSelectedFilters(querystringValues, props);
    this.state = {
      title: retrieveAndDecodeTitle(querystringValues),
      loaded: false,
      results: [],
      // pagination fields
      totalElements: 0,
      page: 0,
      totalPages: 0,
      pageSize: pageSize != null ? pageSize : 10,
      morePages: true,
      // sorts and filters
      allFilters: [],
      selectedFilters: selectedFilters,
      allSortFields: [],
      sortField: sortInfo.field,
      sortDescending: sortInfo.desc
    };
    this.loadContent();
    loadDisplayInfo(this);
    this.snackbar = null;
    this.setSnackbarRef = element => {
      this.snackbar = element;
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const title = retrieveAndDecodeTitle(queryString.parse(this.props.location.search));
    if (title !== prevState.title) {
      this.setState({
        title
      });
    }
    setUpPageInfoFromQueryString(this);
    const querystringValues = queryString.parse(this.props.location.search);
    const sortInfo = determineSortInfoFromQueryString(querystringValues, this.props);
    setUpSortInfoFromQueryString(this, prevState, SORT_FIELD.title, false, sortInfo, querystringValues);
    const filters = retrieveFromQueryString(Q_STRING.FILTERS, querystringValues);
    setUpFiltersFromQueryString(this, prevState, querystringValues, filters);
    if (statesDontMatch('title', prevState, this.state) || statesDontMatch('page', prevState, this.state) || statesDontMatch('pageSize', prevState, this.state)) {
      console.dir('states dont match');
      this.loadContent();
      loadDisplayInfo(this);
    }
  }
  reset() {
    this.setState({
      loaded: false,
      results: [],
      totalElements: 0,
      page: 0,
      totalPages: 0,
      morePages: true
    });
    this.loadContent();
    loadDisplayInfo(this);
  }
  render() {
    const classes = this.props.classes;
    return /*#__PURE__*/React.createElement("div", {
      id: "grid-container",
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      wrap: 'nowrap',
      style: {
        marginTop: '1vh',
        minWidth: '80vw'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 132,
        columnNumber: 17
      }
    }, this.state.loaded === true && /*#__PURE__*/React.createElement(Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 135,
        columnNumber: 21
      }
    }, this.state.totalElements !== 0 && /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 137,
        columnNumber: 25
      }
    }, "Showing results containing \"", this.state.title, "\""), SortsAndFilters(this, classes), Pagination(this.state, this, classes, true), this.state.totalElements !== 0 && /*#__PURE__*/React.createElement(Table, {
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 142,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(TableHead, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 143,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 144,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 145,
        columnNumber: 37
      }
    }, "Title"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 146,
        columnNumber: 37
      }
    }, "Subtitle"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 147,
        columnNumber: 37
      }
    }, "Language"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 148,
        columnNumber: 37
      }
    }, "ProgramType"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 149,
        columnNumber: 37
      }
    }, "Year"))), /*#__PURE__*/React.createElement(TableBody, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 29
      }
    }, this.state.results != null && this.state.results.map(result => /*#__PURE__*/React.createElement(TableRow, {
      hover: true,
      onClick: () => {
        this.navigateToEntityPageForSearchResult(result);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 154,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 157,
        columnNumber: 41
      }
    }, result.title), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 41
      }
    }, result.type === 'SportingEvent' ? result.sportsSubtitle : result.type === 'Episode' ? result.episodeTitle : ''), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 162,
        columnNumber: 41
      }
    }, result.language), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 163,
        columnNumber: 41
      }
    }, result.type), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 164,
        columnNumber: 41
      }
    }, result.year))))), Pagination(this.state, this, classes, false), this.state.totalElements === 0 && /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 172,
        columnNumber: 25
      }
    }, "No results found for search: \"", this.state.title, "\"")), this.state.loaded === false && /*#__PURE__*/React.createElement(Loading, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 177,
        columnNumber: 21
      }
    })));
  }
  navigateToEntityPageForSearchResult(item) {
    let path = ENTITY_SELECTED;
    let search = "".concat(Q_STRING.MERLIN_ID, "=").concat(item.id);
    this.props.history.push({
      pathname: path,
      search: search
    });
  }
  loadContent() {
    this.state.loaded = false;
    this.forceUpdate();
    if (this.state.title == null) {
      Util.openSnackbar("Unable to load search results because title is missing", this.snackbar);
      return;
    }
    let uri = BASE_URIS.prefix + BASE_URIS.listPrograms + "?".concat(TPIS_PARAMS.TITLE, "=").concat(encodeURIComponent(this.state.title)) + "&".concat(TPIS_PARAMS.PAGE, "=") + this.state.page + "&".concat(TPIS_PARAMS.PAGE_SIZE, "=") + this.state.pageSize + "&".concat(TPIS_PARAMS.SORT_FIELD, "=") + this.state.sortField + "&".concat(TPIS_PARAMS.SORT_DESC, "=") + this.state.sortDescending;

    // filters
    if (this.state.selectedFilters != null && this.state.selectedFilters.length > 0) {
      uri += "&".concat(TPIS_PARAMS.FILTERS, "=").concat(this.state.selectedFilters);
    }
    Util.fetchWithRedirect(uri, 'GET', this.props).then(result => {
      if (result.status === 403) {
        console.log("forbidden");
        //noop for now TODO
      } else {
        this.state.results = result.content;
        this.state.loaded = true;
        this.state.morePages = !result.last;
        this.state.totalPages = result.totalPages;
        this.state.totalElements = result.totalElements;
      }
      this.forceUpdate();
    }).catch(error => {
      Util.log('TitleSearch.loadContent', true, error, false);
      this.setState({
        loaded: true
      });
    });
  }
}
export default withStyles(styles)(withRouter(TitleSearch));